import React, { useMemo } from "react";

const SpacingBox = ({
    children,
    pt,
    pr,
    pb,
    pl,
    mt,
    mr,
    mb,
    ml,
    px,
    py,
    mx,
    my,
    p,
    m,
    className,
    cmp: Component = "div",
    ...rest
}) => {
    const spacingStyle = useMemo(() => {
        let _spacingStyle = {};
        px && (_spacingStyle = { ..._spacingStyle, paddingLeft: px, paddingRight: px });
        py && (_spacingStyle = { ..._spacingStyle, paddingTop: py, paddingBottom: py });
        mx && (_spacingStyle = { ..._spacingStyle, marginLeft: mx, marginRight: mx });
        my && (_spacingStyle = { ..._spacingStyle, marginTop: my, marginBottom: my });
        p && (_spacingStyle.padding = p);
        m && (_spacingStyle.margin = m);
        pt && (_spacingStyle.paddingTop = pt);
        pr && (_spacingStyle.paddingRight = pr);
        pb && (_spacingStyle.paddingBottom = pb);
        pl && (_spacingStyle.paddingLeft = pl);
        mt && (_spacingStyle.marginTop = mt);
        mr && (_spacingStyle.marginRight = mr);
        mb && (_spacingStyle.marginBottom = mb);
        ml && (_spacingStyle.marginLeft = ml);
        Object.keys(_spacingStyle)
            .filter(
                styleKey =>
                    _spacingStyle[styleKey].indexOf("px") < 0 &&
                    _spacingStyle[styleKey] !== "auto"
            )
            .forEach(
                styleKey => (_spacingStyle[styleKey] = `${_spacingStyle[styleKey]}px`)
            );
        return _spacingStyle;
    }, [pt, pr, pb, pl, mt, mr, mb, ml, px, py, mx, my, p, m]);
    return (
        <Component
            className={`spacing-box ${className || ""}`}
            style={spacingStyle}
            {...rest}
        >
            {children}
        </Component>
    );
};

export default React.memo(SpacingBox);
